import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ABTestManager from '../components/ABTestManager';
import SEOHead from "../components/SEOHead";
import SkeletonTable from '../components/SkeletonTable';

import { useTranslation } from 'react-i18next';
export default function AbTestingPage() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Helmet>
        <title>A/B Testing Dashboard — Max OS Cloud</title>
        <meta name='description' content='Run A/B tests on your pages, agent messages, and automation flows. Measure what works and make data-driven decisions.' />
      </Helmet>

      <div className='min-h-screen bg-[#09090B] text-white'>
      <SEOHead
        title={t('ab_testing_page.ab_testing_max_employee')}
        description={t('ab_testing_page.max_employee_ab_testing_experiment_with_different')}
        url="/dashboard/ab-testing"
        noIndex
      />
        <Header />

        <section className='border-b border-zinc-900'>
          <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-4 sm:py-6 md:py-10'>
            <div className='font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-2'>// A/B TESTING</div>
            <h1 className='font-display text-2xl sm:text-3xl md:text-4xl uppercase'>
              Experiment & <span className='text-amber-500'>{t('ab_testing_page.optimize')}</span>
            </h1>
            <p className='text-sm sm:text-base text-zinc-500 mt-2 max-w-2xl'>
              Create and manage A/B tests with statistical significance tracking, audience targeting, and results analysis.
            </p>
          </div>
        </section>

        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-4 sm:py-6 md:py-10'>
          {loading ? (
            <SkeletonTable rows={6} columns={5} />
          ) : (
            <ABTestManager />
          )}
        </div>

        <Footer />
      </div>
    </>
  );
}
